import { Menu, MenuItem } from '@mui/material';
import { useState, type MouseEvent } from 'react';

import { IconButton, MoreVertIcon } from '@occc-app/design-system';

type TriggeredMessagesContextMenuProps = {
  messageUuid: string;
  onEditClick: (messageUuid: string) => void;
  onViewDetailsClick: (messageUuid: string) => void;
  isUserPermittedToEdit: boolean;
};

export const TriggeredMessagesContextMenu = (props: TriggeredMessagesContextMenuProps) => {
  const { messageUuid, isUserPermittedToEdit, onEditClick, onViewDetailsClick } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isContextMenuOpen = Boolean(anchorEl);
  const handleContextMenuClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleContextMenuClose = (event: MouseEvent<unknown>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  const canRenderEditOption = isUserPermittedToEdit;

  return (
    <>
      <IconButton
        id='context-menu-button'
        aria-controls={isContextMenuOpen ? 'context-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={isContextMenuOpen ? 'true' : undefined}
        onClick={handleContextMenuClick}
        sx={{ m: -1 }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='context-menu'
        anchorEl={anchorEl}
        open={isContextMenuOpen}
        onClose={handleContextMenuClose}
        MenuListProps={{
          'aria-labelledby': 'context-menu-button',
        }}
      >
        <MenuItem
          onClick={(event) => {
            onViewDetailsClick(messageUuid);
            handleContextMenuClose(event);
          }}
        >
          View Details
        </MenuItem>
        {canRenderEditOption ? (
          <MenuItem
            onClick={(event) => {
              onEditClick(messageUuid);
              handleContextMenuClose(event);
            }}
          >
            Edit
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};
